// const now=

export const initialState = {
    currentDate: new Date().toISOString().split('T')[0],
};
